import NewGoodPractice from "./components/NewGoodPracticeForm";

export default NewGoodPractice